<template>
  <b-navbar v-if="show" id="main-nav" fixed="top" toggleable="false" type="dark">

    <div class="brand-wrapper">
      <router-link :to="{name: 'home'}" class="navbar-brand">
        <img alt="logo" src="../../../assets/images/logo.svg">
      </router-link>
    </div>

    <div v-if="showOrganization">
      <router-link :to="organizationLink()" class="navbar-brand organization">
        {{ organization.name }}
      </router-link>
    </div>

    <b-navbar-nav class="ml-auto">
      <b-dropdown ref="dropdown" toggle-class="text-decoration-none" no-caret right class="main-menu-btn">
        <template slot="button-content">
          <i class="fas fa-bars fa-lg"></i>
        </template>
        <b-dropdown-header><b-alert show variant="primary">{{ client.email }}</b-alert></b-dropdown-header>
        <router-link :to="{name: 'profile'}" class="dropdown-item" @click.native="closeDropdown">
          <i class="fas fa-user-circle"></i>
          <span>Profile</span>
          <span v-if="!client.is_confirmed"><i class="fas fa-exclamation-triangle"></i></span>
        </router-link>
        <router-link
          v-if="showSettings"
          :to="{name: 'content-tree'}"
          class="dropdown-item"
          @click.native="closeDropdown">
          <i class="fas fa-cog"></i>
          <span>Settings</span>
          <span v-if="!client.is_confirmed"><i class="fas fa-exclamation-triangle"></i></span>
        </router-link>
        <router-link :to="{name: 'logout'}" class="dropdown-item" @click.native="closeDropdown">
          <i class="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </router-link>
        <b-dropdown-divider></b-dropdown-divider>
        <a href="https://4lnsteam.atlassian.net/servicedesk/customer/portal/5" target="_blank" class="dropdown-item">
          <i class="fas fa-question-circle"></i>
          <span id="help_link">Help</span>
        </a>
      </b-dropdown>
    </b-navbar-nav>

    <router-link v-if="showConfirmationAlert" :to="{name: 'profile'}" class="confirmation-notice text-center">
      <i class="fas fa-exclamation-triangle"></i>
      Your email needs confirmation
    </router-link>

  </b-navbar>

</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('client', {
      client: 'data'
    }),
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapGetters('client', {
      role: 'getCurrentRole'
    }),
    show () {
      return this.$route.meta.auth
    },
    showSettings () {
      return this.showOrganization && this.role !== 'owner'
    },
    showOrganization () {
      if (this.$route.name === 'edit-organization') {
        return false
      }

      return 'organization' in this.$route.params
    },
    showConfirmationAlert () {
      if (this.client.is_confirmed || this.$route.name === 'profile') {
        return false
      }

      return true
    }
  },
  methods: {
    closeDropdown (event) {
      this.$refs.dropdown.visible = false
    },
    organizationLink () {
      if (this.$route.meta.admin) {
        return { name: 'admin-modules' }
      }

      return { name: 'client-modules' }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
#main-nav {
  background-color: $brand-dark-primary;

  .organization {
    text-transform: uppercase;
    font-size: 1.6rem;
    padding: 0;
    letter-spacing: 3px;
    color: $organization-primary;

    &:hover {
      color: $organization-secondary;
    }
  }

  .confirmation-notice {
    position: absolute;
    width: 300px;
    height: auto;
    border-radius: 0 0 0.25rem 0.25rem;
    padding: $spacing-xs;
    top: 0;
    left: 50%;
    margin-left: -150px;
    border: 1px solid $medium-grey;
    border-top: none;
    color: $light-grey;
    text-decoration: none;
    background-color: rgba(255,255,255,0.05);

    &:hover {
      color: $brand-dark-primary;
      background: $light-grey;
    }
  }

  .fa-exclamation-triangle {
    color: $error-primary;
  }

  .brand-wrapper {
    width: 50px;
    height: 100%;

    img {
      width: 100%;
      height: auto;
    }
  }

  .dropdown-item {
    color: $medium-grey;
    display: flex;
    align-items: center;

    &>span {
      margin-left: $spacing-xs;
    }

    &:focus {
      outline: none;
    }

    &.router-link-exact-active {
      color: $dark-primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/index.vue